import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagLY = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M2.48 14.131A24.9 24.9 0 0 0 0 25.001a24.9 24.9 0 0 0 2.48 10.87L25 38.043l22.519-2.174A24.9 24.9 0 0 0 49.999 25a24.9 24.9 0 0 0-2.48-10.869l-22.52-2.174-22.518 2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M2.481 35.87C6.525 44.232 15.088 50 25 50c9.912 0 18.475-5.768 22.518-14.13H2.481Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M2.481 14.13h45.037C43.474 5.768 34.91 0 24.998 0 15.088 0 6.525 5.768 2.481 14.13Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m30.819 20.427 2.05 2.826 3.323-1.077-2.055 2.825 2.051 2.826-3.32-1.081-2.055 2.824.002-3.492-3.32-1.081 3.322-1.078.002-3.492Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25.22 32.065a7.065 7.065 0 1 1 3.361-13.281 8.695 8.695 0 1 0 0 12.432c-1 .541-2.144.849-3.36.849Z"
}));
FlagLY.displayName = 'FlagLY';
export default withFlagWrapper(FlagLY);
//# sourceMappingURL=index.js.map